import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { LocalizedLink } from 'src/components/common/LocalizedLink';
import Picture from '@/image/hotel/picture9.png';

interface Property {
  property_id: number;
  images: string[];
  title: string;
  description: string;
  availability: string;
  area: string;
  subarea: string; // 追加
  rent: string;
  roomDetails: string;
  area_id: string;
  station_distance: string;
}

interface PropertyCardProps {
  property: Property;
}

export const PropertyCard: React.FC<PropertyCardProps> = ({ property }) => {
  return (
    <div className="max-w-[350px] md:max-w-[300px] mx-auto">
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        navigation
        modules={[Navigation]}
      >
        {property.images.map((image, index) => (
          <SwiperSlide key={index} className="flex justify-center">
            <img
              src={image}
              alt={`Property image ${index + 1}`}
              className="w-auto h-[250px] md:w-[300px] md:h-[213px] object-cover"
              onError={(e) => {
                e.currentTarget.src = Picture;
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="py-2">
        <p className="text-[10px]">{property.description}</p>
        <LocalizedLink to={`/monthly/${property.property_id}`}>
          <h2 className="underline text-2xl max-md:mt-4">{property.title}</h2>
        </LocalizedLink>
      </div>

      <div className="text-[12px]">
        <div className="flex flex-col mb-5">
          <div className="text-[9px] h-4">Area:</div>
          <div className="text-[17px]">
            {property.area},{property.subarea}
          </div>
        </div>
        <div className="text-sm">{property.availability}</div>
        <div className="flex mb-3 text-[19px]">
          <p>{property.rent}</p>
        </div>
        <div className="flex text-[11px]">
          <p
            dangerouslySetInnerHTML={{
              __html: property.station_distance || '',
            }}
          />
        </div>
      </div>

      <div className="flex justify-center my-8">
        <LocalizedLink
          to={`/monthly/${property.property_id}`}
          className="bg-black px-3 py-2 text-white text-[15px]"
          onClick={() => {
            // クリアするキーを指定
            localStorage.removeItem('applyForm_textData');
            localStorage.removeItem('reservationError');
            // ※必要に応じて他のキーも削除可能です
          }}
        >
          View Rooms
        </LocalizedLink>
      </div>
    </div>
  );
};

export default PropertyCard;
